// src/App.js

import React, {
    useState,
    useEffect,
} from "react";

import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";

import AdminLayout from "./layout/AdminLayout";


// =========================================================
// AUTH
// =========================================================

import Login from "./Login";


// =========================================================
// DASHBOARD
// =========================================================

import Dashboard from "./pages/Dashboard";


// =========================================================
// MODERATION
// =========================================================

import Reports from "./pages/moderation/Reports";
import ModerationSearch from "./pages/moderation/ModerationSearch";
import ReviewManager from "./pages/ReviewManager";


// =========================================================
// ROLES
// =========================================================

import UserList from "./pages/UserList";

import ShopManager from "./pages/ShopManager";
import ShopDetails from "./pages/ShopDetails";

import StoresManager from "./pages/stores/StoresManager";
import StoreDetails from "./pages/stores/StoreDetails";


// =========================================================
// APPROVALS
// =========================================================

import ShopRequests from "./pages/approvals/ShopRequests";
import PendingClaims from "./pages/PendingClaims";
import ChangeRequestManager from "./pages/ChangeRequestManager";
import StoreRequests from "./pages/approvals/StoreRequests";
import AssignManager from "./pages/AssignManager";


// =========================================================
// OPS
// =========================================================

import ShopImporter from "./pages/ShopImporter";
import SalesManager from "./pages/SalesManager";
import Messages from "./pages/Messages";
import UncategorisedShops from "./pages/UncategorisedShops";
import Announcements from "./pages/Announcements";


// =========================================================
// ADS
// =========================================================

import Ads from "./pages/Ads";


// =========================================================
// TOOLS
// =========================================================

import ResetPassword from "./pages/ResetPassword";


// =========================================================
// STYLES
// =========================================================

import "./App.css";


/* =========================================================
   APP
========================================================= */

function App() {

    const [
        isLoggedIn,
        setIsLoggedIn,
    ] =
        useState(false);


    /* =====================================================
       CHECK ADMIN LOGIN
    ===================================================== */

    useEffect(
        () => {

            const loggedIn =
                localStorage.getItem(
                    "isAdmin"
                ) === "true";


            setIsLoggedIn(
                loggedIn
            );

        },
        []
    );


    /* =====================================================
       LOGIN
    ===================================================== */

    const handleLogin =
        () => {

            setIsLoggedIn(
                true
            );
        };


    /* =====================================================
       NOT LOGGED IN
    ===================================================== */

    if (
        !isLoggedIn
    ) {
        return (
            <Login
                onLogin={
                    handleLogin
                }
            />
        );
    }


    /* =====================================================
       ROUTES
    ===================================================== */

    return (

        <Router>

            <AdminLayout>

                <Switch>

                    {/* =====================================
                        DEFAULT
                    ====================================== */}

                    <Route
                        exact
                        path="/"
                    >
                        <Redirect to="/dashboard" />
                    </Route>


                    {/* =====================================
                        DASHBOARD
                    ====================================== */}

                    <Route
                        exact
                        path="/dashboard"
                        component={
                            Dashboard
                        }
                    />


                    {/* =====================================
                        MODERATION
                    ====================================== */}

                    <Route
                        exact
                        path="/moderation/reports"
                        component={
                            Reports
                        }
                    />

                    <Route
                        exact
                        path="/moderation/search"
                        component={
                            ModerationSearch
                        }
                    />

                    <Route
                        exact
                        path="/moderation/reviews"
                        component={
                            ReviewManager
                        }
                    />


                    {/* =====================================
                        ROLES
                    ====================================== */}

                    <Route
                        exact
                        path="/roles/shoppers"
                        component={
                            UserList
                        }
                    />


                    {/* OP SHOPS */}

                    <Route
                        exact
                        path="/roles/opshops"
                        component={
                            ShopManager
                        }
                    />

                    <Route
                        exact
                        path="/roles/opshops/:shopId"
                        component={
                            ShopDetails
                        }
                    />


                    {/* STORES */}

                    <Route
                        exact
                        path="/roles/stores"
                        component={
                            StoresManager
                        }
                    />

                    <Route
                        exact
                        path="/roles/stores/:storeId"
                        component={
                            StoreDetails
                        }
                    />


                    {/* =====================================
                        APPROVALS
                    ====================================== */}

                    <Route
                        exact
                        path="/approvals/shop-requests"
                        component={
                            ShopRequests
                        }
                    />

                    <Route
                        exact
                        path="/approvals/claims"
                        component={
                            PendingClaims
                        }
                    />

                    <Route
                        exact
                        path="/approvals/changes"
                        component={
                            ChangeRequestManager
                        }
                    />

                    <Route
                        exact
                        path="/approvals/store-requests"
                        component={
                            StoreRequests
                        }
                    />

                    <Route
                        exact
                        path="/approvals/managers"
                        component={
                            AssignManager
                        }
                    />


                    {/* =====================================
                        OPS
                    ====================================== */}

                    <Route
                        exact
                        path="/ops/import"
                        component={
                            ShopImporter
                        }
                    />

                    <Route
                        exact
                        path="/ops/sales"
                        component={
                            SalesManager
                        }
                    />

                    <Route
                        exact
                        path="/ops/messages"
                        component={
                            Messages
                        }
                    />

                    <Route
                        exact
                        path="/ops/uncategorised"
                        component={
                            UncategorisedShops
                        }
                    />

                    <Route
                        exact
                        path="/ops/announcements"
                        component={
                            Announcements
                        }
                    />


                    {/* =====================================
                        ADS
                    ====================================== */}

                    <Route
                        exact
                        path="/ads"
                        component={
                            Ads
                        }
                    />


                    {/* =====================================
                        TOOLS
                    ====================================== */}

                    <Route
                        exact
                        path="/reset-password"
                        component={
                            ResetPassword
                        }
                    />


                    {/* =====================================
                        LEGACY ROUTES
                        
                        Keep old bookmarks / URLs working.
                    ====================================== */}

                    <Route
                        exact
                        path="/shops"
                    >
                        <Redirect to="/roles/opshops" />
                    </Route>


                    <Route
                        exact
                        path="/users"
                    >
                        <Redirect to="/roles/shoppers" />
                    </Route>


                    <Route
                        exact
                        path="/reviews"
                    >
                        <Redirect to="/moderation/reviews" />
                    </Route>


                    <Route
                        exact
                        path="/pending-claims"
                    >
                        <Redirect to="/approvals/claims" />
                    </Route>


                    <Route
                        exact
                        path="/change-requests"
                    >
                        <Redirect to="/approvals/changes" />
                    </Route>


                    <Route
                        exact
                        path="/import-shops"
                    >
                        <Redirect to="/ops/import" />
                    </Route>


                    <Route
                        exact
                        path="/messages"
                    >
                        <Redirect to="/ops/messages" />
                    </Route>


                    {/* =====================================
                        OLD ADS ROUTE
                        
                        If /ads/ads was ever bookmarked,
                        send it to the new route.
                    ====================================== */}

                    <Route
                        exact
                        path="/ads/ads"
                    >
                        <Redirect to="/ads" />
                    </Route>


                    {/* =====================================
                        FALLBACK
                    ====================================== */}

                    <Route path="*">
                        <Redirect to="/dashboard" />
                    </Route>

                </Switch>

            </AdminLayout>

        </Router>
    );
}


export default App;